package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.uscreen.serialization.CtaActionSerializer

@Serializable
data class UScreenCta(
    @SerialName("text") val text: String,
    @SerialName("action") val action: CtaAction = CtaAction.Next,
    @SerialName("shimmer") val shimmer: Boolean = false,
    @SerialName("gradient") val gradient: List<String>? = null,
    @SerialName("style") val style: String? = null,
    @SerialName("requiresKey") val requiresKey: String? = null,
    @SerialName("transition") val transition: BlockTransition? = null,
) {
    companion object {
        val preview = UScreenCta(
            text = "Continue",
            shimmer = true,
        )
    }
}

@Serializable(with = CtaActionSerializer::class)
sealed interface CtaAction {
    // String-form actions
    data object Next : CtaAction
    data object Back : CtaAction
    data object SignIn : CtaAction
    data object Restore : CtaAction
    data object Purchase : CtaAction
    data object RequestTracking : CtaAction
    data object RequestNotifications : CtaAction

    // Object-form actions
    data class OpenUrl(val url: String) : CtaAction
    data class GoToScreen(val screen: String) : CtaAction
}
